import { createSlice } from "@reduxjs/toolkit";

const initialWhCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  whCategoryForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const whCategorySlice = createSlice({
  name: "whCategory",
  initialState: initialWhCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    whCategoryFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    whCategoryAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    whCategoryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.whCategory.push(action.payload.whCategory);
    },
    whCategoryDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.whCategory.filter(
        (el) => el.catalog_category_id !== action.payload.id,
      );
    },
    getWhCategory: (state, action) => {
      state.actionsLoading = false;
      state.whCategoryForEdit = action.payload.whCategoryForEdit;
      state.error = null;
    },
    // updateProduct
    whCategoryUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.whCategory = state.entities.whCategory.map((entity) => {
        if (
          entity.catalog_category_id ===
          action.payload.whCategory.catalog_category_id
        ) {
          return action.payload.whCategory;
        }
        return entity;
      });
    },
  },
});
